import { Link } from "react-router-dom";

interface Props {
  onShare: () => void;
}

export default function HotRanking({ onShare }: Props) {
  return (
    <aside className="rounded-lg border hairline bg-gradient-to-b from-background-900/90 to-background-950/80 overflow-hidden">
      <div className="px-4 py-3.5 border-b hairline flex items-center justify-between">
        <h2 className="text-sm font-medium text-foreground-50 flex items-center gap-2">
          <span className="w-6 h-6 rounded flex items-center justify-center bg-accent-500/15 text-accent-400">
            <i className="ri-fire-line text-sm" />
          </span>
          热门排行榜
        </h2>
        <Link to="/category/action" className="text-[11px] text-foreground-400 hover:text-accent-300 transition-colors whitespace-nowrap">
          更多
        </Link>
      </div>
      <ol className="p-2.5 space-y-1">
        {[
          { rank: 1, title: "剑道流浪帖", sub: "156.0万阅读", to: "/detail/jiandao-liulang" },
          { rank: 2, title: "机甲代号07", sub: "142.0万阅读", to: "/detail/jijia-daihao-07" },
          { rank: 3, title: "决斗天下", sub: "134.5万阅读", to: "/detail/juedou-tianxia" },
          { rank: 4, title: "赤焰觉醒", sub: "128.4万阅读", to: "/detail/chiyan-juexing" },
          { rank: 5, title: "十三号密室", sub: "110.3万阅读", to: "/detail/shisan-hao-mishi" },
          { rank: 6, title: "星河里的你", sub: "96.2万阅读", to: "/detail/xinghe-qingnian" },
        ].map((item) => (
          <li key={item.rank}>
            <Link
              to={item.to}
              className="flex items-center gap-3 px-2.5 py-2.5 rounded-md hover:bg-background-800/70 transition-colors group"
            >
              <span
                className={`w-6 h-6 rounded text-[11px] font-label flex items-center justify-center shrink-0 ${
                  item.rank <= 3
                    ? "bg-accent-500 text-background-950"
                    : "bg-background-800 text-foreground-400 border hairline"
                }`}
              >
                {item.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[13px] text-foreground-100 truncate group-hover:text-accent-300 transition-colors">
                  {item.title}
                </span>
                <span className="block text-[11px] text-foreground-500 mt-0.5">{item.sub}</span>
              </span>
              <i className="ri-arrow-right-up-line text-foreground-600 group-hover:text-accent-400 transition-colors" />
            </Link>
          </li>
        ))}
      </ol>
      <div className="px-3.5 pb-3.5">
        <button
          type="button"
          onClick={onShare}
          className="w-full h-9 rounded-md border border-accent-500/40 bg-accent-500/10 text-accent-300 text-xs flex items-center justify-center gap-1.5 hover:bg-accent-500/20 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-share-forward-line" />
          分享给同好
        </button>
      </div>
    </aside>
  );
}